import { render, staticRenderFns } from "./other-conversations.vue?vue&type=template&id=8bd04570&scoped=true&"
import script from "./other-conversations.vue?vue&type=script&lang=js&"
export * from "./other-conversations.vue?vue&type=script&lang=js&"
import style0 from "./other-conversations.vue?vue&type=style&index=0&id=8bd04570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd04570",
  null
  
)

export default component.exports